<template>
  <div style="position: relative">
    <qrcode-stream :camera="camera" @decode="onDecode" @init="onInit">
      <div v-if="validationSuccess" class="validation-success">Inloggen</div>

      <div v-if="validationFailure" class="validation-failure">
        Niet geldig!
      </div>

      <div v-if="error" class="validation-failure">
        Er ging iets mis, probeer later opnieuw.
      </div>

      <div v-if="validationPending" class="validation-pending">
        Valideren...
      </div>
    </qrcode-stream>
    <div class="btn btn-dark" @click="toggleCamera">
      <span class="mdi mdi-sync" />
    </div>
  </div>
</template>

<script>
import { QrcodeStream } from 'vue-qrcode-reader/dist/VueQrcodeReader.umd';
import { loginQR } from '@/api';
import { UnautorisedApiError } from '@/api/apiErrors';
import { addDeviceNameToUrl } from '@/utils/device';

export default {
  components: { QrcodeStream },

  data() {
    return {
      isValid: undefined,
      camera: 'rear',
      result: null,
      error: false,
      validationPending: false,
      initPending: true,
    };
  },

  computed: {
    validationSuccess() {
      return this.isValid === true;
    },

    validationFailure() {
      return this.isValid === false;
    },
  },

  methods: {
    toggleCamera() {
      if (this.camera === 'front') {
        this.camera = 'rear';
      } else {
        this.camera = 'front';
      }
    },
    onInit(promise) {
      promise.catch(console.error).then(this.resetValidationState);
    },

    resetValidationState() {
      this.isValid = undefined;
      this.error = false;
    },

    async onDecode(content) {
      this.result = content;
      this.turnCameraOff();

      try {
        this.validationPending = true;
        await loginQR(content.replace('URL:', ''));
        window.location.href = addDeviceNameToUrl(`${process.env.VUE_APP_BASE_URL}/v1/authorize`);
      } catch (e) {
        if (e instanceof UnautorisedApiError) {
          this.isValid = false;
        } else {
          this.error = true;
        }
        this.validationPending = false;
        // some more delay, so users have time to read the message
        await this.timeout(2000);

        this.turnCameraOn();
        console.error(e);
      }
    },

    turnCameraOn() {
      this.camera = 'auto';
    },

    turnCameraOff() {
      this.camera = 'off';
    },

    timeout(ms) {
      return new Promise((resolve) => {
        window.setTimeout(resolve, ms);
      });
    },
  },
};
</script>

<style scoped>
.validation-success,
.validation-failure,
.validation-pending {
  position: absolute;
  width: 100%;
  height: 100%;

  background-color: rgba(255, 255, 255, 0.8);
  text-align: center;
  font-weight: bold;
  font-size: 1.4rem;
  padding: 10px;

  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
}
.validation-success {
  color: green;
}
.validation-failure {
  color: red;
}
.btn {
  position: absolute;
  top: 1rem;
  right: 2rem;
}
</style>
